import {gsap} from 'gsap'


function timeLine(){
    const tl = gsap.timeline()
    tl.from('.p-fv__container-img',{
        x:-200,
        y:-100,
        duration: 1.4,
        ease:"expo.out",
        opacity:0,
        skewY:-6,
    })
    tl.from('h1',{
        y:60,
        duration: 1.2,
        ease:"expo.out",
        opacity:0,
        skewY:-6,
    },"-=.8")
    tl.from('.p-fv__container-copy h2',{
        y:20,
        duration: .6,
        ease:"expo.out",
        opacity:0,
    },"-=.8")
    tl.from('.p-fv__container-copy p',{
        y:20,
        duration: 1,
        ease:"expo.out",
        opacity:0,
    },"-=.6")
    
    tl.from('.divider',{
        x:-20,
        duration: .3,
        ease:"expo.out",
        opacity:0, 
    },"-=.8")
    tl.from('.p-fv__container-copy__presenter',{
        duration: 1,
        ease:"expo.out",
        opacity:0,
        y:20,
    },"-=.4")
    tl.from('.p-fv__container-copy__notice',{
        y:20,
        duration: 1.2,
        ease:"expo.out",
        opacity:0,
    },"-=.1")
}

export default timeLine